import Icon from '../components/Icon.vue'

Icon.register({
  bus: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M488 128c13.3 0 24 10.7 24 24v80c0 13.3-10.8 24-24 24h-8v166.4c0 12.8-9.6 25.6-25.6 25.6h-6.4v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32h-192v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32c-17.7 0-32-14.3-32-32v-160h-8c-13.3 0-24-10.8-24-24v-80c0-13.3 10.8-24 24-24h8v-48c0-44.8 99.2-80 224-80s224 35.2 224 80v48h8zM112 400c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM128 288h256c17.7 0 32-14.3 32-32v-128c0-17.7-14.3-32-32-32h-256c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32zM400 400c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bus.js
// module id = 1131
// module chunks = 0